import { computed } from 'vue';
import { helpers, required } from '@vuelidate/validators';
import { checkNameUniq } from '@/services/merchant.service';
import { NETWORK_CONSTANTS } from '../constants/network';

export function useNetworkValidation() {
  const notEmptyMessage = computed(() => NETWORK_CONSTANTS.VALIDATION_MESSAGES.REQUIRED);
  const nameUniq = computed(() => NETWORK_CONSTANTS.VALIDATION_MESSAGES.NAME_TAKEN);

  const asyncCheckNameUniq = async (value) => {
    console.log('asyncCheckNameUniq called with:', value);
    if (!value) {
      console.log('Empty value, skipping validation');
      return true;
    }
    const isUnique = await checkNameUniq(value);
    console.log('API response for', value, ':', isUnique);
    return isUnique;
  };

  // Синхронные правила для кнопки "Сохранить"
  const syncValidationRules = computed(() => {
    console.log('Sync validation rules computed');
    return {
      merchantSlugName: {
        required: helpers.withMessage(notEmptyMessage.value, required),
        minLength: helpers.withMessage(NETWORK_CONSTANTS.VALIDATION_MESSAGES.MIN_LENGTH, (value) => {
          if (!value) return true;
          return value.length >= NETWORK_CONSTANTS.MIN_NAME_LENGTH;
        }),
        maxLength: helpers.withMessage(NETWORK_CONSTANTS.VALIDATION_MESSAGES.MAX_LENGTH, (value) => {
          if (!value) return true;
          return value.length <= NETWORK_CONSTANTS.MAX_NAME_LENGTH;
        }),
        url: helpers.withMessage(NETWORK_CONSTANTS.VALIDATION_MESSAGES.URL_PATTERN, (value) => {
          if (!value) return true;
          return /^[a-zA-Z0-9-]+$/.test(value);
        }),
      },
    };
  });

  // Асинхронные правила для ввода символов
  const asyncValidationRules = computed(() => {
    console.log('Async validation rules computed');
    return {
      merchantSlugName: {
        checkNameUniq: helpers.withMessage(nameUniq.value, helpers.withAsync(asyncCheckNameUniq)),
      },
    };
  });

  return {
    syncValidationRules,
    asyncValidationRules,
  };
}
